module.exports = __webpack_public_path__ + "static/media/music.bfec5e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/anniversary/music.mp3
// module id = 4+CO
// module chunks = 1